export default "__VITE_ASSET__Db27Ic_C__"